import React from 'react';
import { AccordionHeader } from "./accordion-header.js";
import { AccordionPanel } from "./accordion-panel.js";

/**
 * A single accordion with a header and panel.
 * @param {AccordionProps} props AccordionProps
 */
var Accordion = function Accordion(props) {
  var accordion = props.accordion,
    animation = props.animation,
    disabled = props.disabled,
    focusIndex = props.focusIndex,
    id = props.id,
    index = props.index,
    loading = props.loading,
    onChange = props.onChange,
    onKeyUp = props.onKeyUp,
    open = props.open,
    unmountOnExit = props.unmountOnExit;
  var accordionButtonId = "".concat(id, "-button-").concat(index);
  var accordionPanelId = "".concat(id, "-panel-").concat(index);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccordionHeader, {
    accordionPanelId: accordionPanelId,
    buttonIcon: accordion.buttonIcon,
    buttonIconPosition: accordion.buttonIconPosition,
    buttonProps: accordion.buttonProps,
    disabled: disabled,
    focusIndex: focusIndex,
    headerContent: accordion.headerContent,
    headerContentPosition: accordion.headerContentPosition,
    headingProps: accordion.headingProps,
    id: accordionButtonId,
    index: index,
    onChange: onChange,
    onKeyUp: onKeyUp,
    open: open,
    showText: accordion.showText
  }, accordion.button), /*#__PURE__*/React.createElement(AccordionPanel, {
    accordionButtonId: accordionButtonId,
    animation: animation,
    id: accordionPanelId,
    loading: loading,
    open: open,
    panelProps: accordion.panelProps,
    unmountOnExit: unmountOnExit
  }, accordion.panel));
};
export { Accordion };